module.exports = __webpack_public_path__ + "static/media/help support.37246508.png";